import { API } from '@aws-amplify/api';
import { Role } from '../../@types/auth';
import { CognitoUser, UserListUser } from '../../@types/user';
import getRole from '../getRole';


const MAX_USERS_TO_FETCH = 1500;
export async function getUserList(): Promise<UserListUser[]> {
  try {
    const apiName = process.env.NEXT_PUBLIC_DASH_API_NAME!;
    const path = 'get-user-list';
    let token: string | undefined = undefined;
    let users: CognitoUser[] = [];
    do {
      const response: { users: CognitoUser[]; nextToken: string | undefined } = await API.get(
        apiName,
        path,
        { queryStringParameters: { nextToken: token } }
      );
      console.log('Fetched users', response.users.length);
      users.push(...response.users);
      token = response.nextToken;
      if (response.users.length !== MAX_USERS_TO_FETCH) break;
    } while (token);
    // Convert CognitoUser to UserListUser
    const returnUsers = users.map((user: CognitoUser) => {
      const group = user.groups?.length > 0 ? user.groups[0] : 0;
      const outputUser: UserListUser = {
        name: user.name,
        email: user.email,
        image: user.image,
        verified: user.verified,
        group,
        level: user.level,
        campusId: user.campusId,
        role: getRole(group?.toString()),
        studentId: undefined,
        studentIds: undefined,
      };

      if (user.studentIds.length > 0) {
        outputUser.studentIds = user.studentIds;

        if (outputUser.role === Role.STUDENT && user.studentIds[0] !== '%') {
          outputUser.studentId = user.studentIds[0];
        }
      }

      return outputUser;
    });

    return returnUsers;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
